import { MarketExprtChargeCodesPanel } from "../MarketExprtChargeCodesPanel";
import { MarketExprtOutputFiltersPanel } from "../MarketExprtOutputFiltersPanel";
import { RateIndexAdditionalOptionsPanel } from "../RateIndexAdditionalOptionsPanel";
import { RateIndexControlMainPanel } from "../RateIndexControlMainPanel";
import { Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMpactControl extends Layout {
    checkbox34: Checkbox;
    checkbox45: Checkbox;
    checkbox46: Checkbox;
    checkbox47: Checkbox;
    checkbox48: Checkbox;
    checkboxActualDelivery: Checkbox;
    checkboxActualPickup: Checkbox;
    checkboxBrkTotalPaid: Checkbox;
    checkboxCarrierLoading: Checkbox;
    checkboxCarrierPayAdjustments: Checkbox;
    checkboxCarrierStopPay: Checkbox;
    checkboxCarrierType: Checkbox;
    checkboxCommodity: Checkbox;
    checkboxConsigneeAddress: Checkbox;
    checkboxCubicFeet: Checkbox;
    checkboxCustAccessorials: Checkbox;
    checkboxCustFuelSurcharge: Checkbox;
    checkboxCustStopCharges: Checkbox;
    checkboxDeliveryAppt: Checkbox;
    checkboxDeliveryApptTime: Checkbox;
    checkboxDestAppEnd: Checkbox;
    checkboxDestCity: Checkbox;
    checkboxDestState: Checkbox;
    checkboxDestZip: Checkbox;
    checkboxDispatcher: Checkbox;
    checkboxFreightClass: Checkbox;
    checkboxFreightValue: Checkbox;
    checkboxHazmat: Checkbox;
    checkboxLinearFeet: Checkbox;
    checkboxLoadNumber: Checkbox;
    checkboxLocationName: Checkbox;
    checkboxMiscNames: Checkbox;
    checkboxMode: Checkbox;
    checkboxMoveDistance: Checkbox;
    checkboxOperationsUser: Checkbox;
    checkboxOrderBookTm: Checkbox;
    checkboxOriginCity: Checkbox;
    checkboxOriginState: Checkbox;
    checkboxOriginZip: Checkbox;
    checkboxPayDate: Checkbox;
    checkboxPaymentTerms: Checkbox;
    checkboxPickupAppt: Checkbox;
    checkboxPickupApptEnd: Checkbox;
    checkboxPickupApptTime: Checkbox;
    checkboxScacCode: Checkbox;
    checkboxServiceLevel: Checkbox;
    checkboxShipmentExcpt: Checkbox;
    checkboxShipperAddress: Checkbox;
    checkboxSpotOrContract: Checkbox;
    checkboxTotalPaid: Checkbox;
    checkboxTotalPickups: Checkbox;
    checkboxTotalStopOffs: Checkbox;
    checkboxTrailerDetail: Checkbox;
    checkboxTrailerType: Checkbox;
    checkboxUnitsType: Checkbox;
    checkboxWeight: Checkbox;
    checkboxmPactUnitCount: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    labelMarketInsight: Label;
    labelMarketRateExport: Label;
    labelOutputSettings: Label;
    labelRateOptions: Label;
    labelRateTypes: Label;
    layout4: MarketExprtChargeCodesPanel;
    layout5: MarketExprtOutputFiltersPanel;
    layoutAdditionalOptions: RateIndexAdditionalOptionsPanel;
    layoutRateIndexGeneral: RateIndexControlMainPanel;
    marketInsightPanel: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panel5: Panel;
    panel6: Panel;
    panel8: Panel;
    panel9: Panel;
    panelMarketExportSection: Panel;
    panelMpact: Panel;
    rateIndexSection: Panel;
    sourceExchangeControl: DataSource;
    sourceMarketrateExprt: DataSource;
    sourceRateIndexControl: DataSource;
    switchAutoRateRetrieval: Switch;
    switchDisplaySellRates: Switch;
    switchEnableMarketInsight: Switch;
    switchInternalRates: Switch;
    switchSpotRates: Switch;
    switchUseMarketRateFuelSurcharge: Switch;
    textbox1: Textbox;
    textbox2: Textbox;
    textbox3: Textbox;
    textbox8: Textbox;
    textbox9: Textbox;
    textboxCarrierName: Textbox;
    textboxCompanyType: Textbox;
    textboxConsigneeName: Textbox;
    textboxContactMethod: Textbox;
    textboxCustomerId: Textbox;
    textboxCustomerName: Textbox;
    textboxPublishWhen: Textbox;
    textboxShipperName: Textbox;
}
